import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// login part
import login from '@/components/login/views/login.vue'
import singIn from '@/components/login/views/singIn.vue'
import singUp from '@/components/login/views/singUp.vue'
import findPwd from '@/components/login/views/findPwd.vue'

// board part
import board from '@/components/board/views/board.vue'
import mainBoard from '@/components/board/views/mainBoard.vue'
import enroll from '@/components/board/views/enroll.vue'
import list from '@/components/board/views/list.vue'
import feeInfo from '@/components/board/views/feeInfo.vue'
import myInfo from '@/components/board/views/myInfo.vue'
import follower from '@/components/board/views/follower.vue'
import followerInfo from '@/components/board/views/followerInfo.vue'
import followerRequest from '@/components/board/views/followerRequest.vue'
import advertiseInfo from '@/components/board/views/advertiseInfo.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: login,
      children: [
        {
          path: '',
          name: 'signIn',
          component: singIn
        },
        {
          path: '/sign-up',
          name: 'signUp',
          component: singUp
        },
        {
          path: '/find-pwd',
          name: 'findPwd',
          component: findPwd
        }
      ]
    },
    {
      path: '/board',
      component: board,
      redirect: {
        name: 'mainBoard'
      },
      children: [
        {
          path: 'main-board',
          name: 'mainBoard',
          component: mainBoard
        },
        {
          path: 'enroll',
          name: 'enroll',
          component: enroll
        },
        {
          path: 'list',
          name: 'list',
          component: list
        },
        {
          path: 'advertise-info/:adId',
          name: 'advertiseInfo',
          component: advertiseInfo
        },
        {
          path: 'fee-info',
          name: 'feeInfo',
          component: feeInfo
        },
        {
          path: 'myInfo',
          name: 'myInfo',
          component: myInfo
        },
        {
          path: 'follower',
          name: 'follower',
          component: follower,
          redirect: {
            name: 'followerInfo'
          },
          children: [
            {
              path: 'info',
              name: 'followerInfo',
              component: followerInfo
            },
            {
              path: 'request',
              name: 'followerRequest',
              component: followerRequest
            }
          ]
        }
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // toRoute store에 기록
  store.commit('setToRoute', {toRoute: to.name})

  // region데이터
  if (store.getters.getRegionList == null) {
    let regionResponse = await store.dispatch('regionListApi')
    store.commit('setRegionList', {regionList: regionResponse.data.data})
  }
  // districtAll데이터
  if (store.getters.getDistrictAllList == null) {
    let districtAllResponse = await store.dispatch('districtListAllApi')
    store.commit('setDistrictAllList', {districtAllList: districtAllResponse.data.data})
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js